export default __webpack_public_path__ + "static/media/play.be653b20.svg";